import React, { useState } from 'react';
import axios from 'axios';

const MapboxCustomSearch = ({ map, inDialog = false }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  const handleSearch = async (e) => {
    const value = e.target.value;
    setQuery(value);

    if (value.length > 2) {
      try {
        const response = await axios.get(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(value)}.json`,
          {
            params: {
              access_token: process.env.REACT_APP_MAPBOX_TOKEN,
              limit: 5,
            },
          }
        );
        setResults(response.data.features);
      } catch (error) {
        console.error('Search failed:', error);
      }
    } else {
      setResults([]);
    }
  };

  const handleSelect = (place) => {
    if (!map) {
      console.error('Map is not ready yet.');
      return;
    }

    try {
      const [lng, lat] = place.center;
      console.log('Flying to:', lng, lat); // Debug log
      
      // Check if map has loaded
      if (map.loaded && map.loaded()) {
        map.flyTo({ center: [lng, lat], zoom: 17, duration: 1500 });
      } else {
        // If map not loaded, wait for it
        map.once('load', () => {
          map.flyTo({ center: [lng, lat], zoom: 17, duration: 1500 });
        });
      }
      
      setQuery(place.place_name);
      setResults([]);
    } catch (error) {
      console.error('Error flying to location:', error);
    }
  };

  return (
    <div
      className="search-map"
      style={{
        position: inDialog ? 'absolute' : 'fixed',
        top: inDialog ? 10 : 90,
        left: inDialog ? '10px' : '50%',
        transform: inDialog ? 'none' : 'translateX(-50%)',
        zIndex: 10000,
        fontFamily: 'Arial, sans-serif',
        width: inDialog ? '280px' : '320px',
      }}
    >
      <input
        type="text"
        value={query}
        onChange={handleSearch}
        placeholder="Search location..."
        style={{
          padding: '10px 14px',
          width: '100%',
          borderRadius: '6px',
          border: '1px solid #ccc',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
          fontSize: '14px',
        }}
      />
      {results.length > 0 && (
        <ul
          style={{
            background: 'white',
            listStyle: 'none',
            padding: '0',
            marginTop: '6px',
            maxHeight: '220px',
            overflowY: 'auto',
            border: '1px solid #ddd',
            borderRadius: '6px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          }}
        >
          {results.map((place) => (
            <li
              key={place.id}
              onClick={() => handleSelect(place)}
              style={{
                padding: '10px 14px',
                cursor: 'pointer',
                borderBottom: '1px solid #f0f0f0',
                transition: 'background-color 0.2s',
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#f5f5f5')}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'white')}
            >
              {place.place_name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MapboxCustomSearch;

